import { Injectable } from '@angular/core';

export type AboutHighlight = {
  title: string;
  description: string;
};

export type AboutContent = {
  badge: string;
  heading: string;
  lede: string;
  body: string;
  ctaLabel: string;
  ctaHref: string;
  imageSrc: string;
  imageAlt: string;
  highlights: AboutHighlight[];
};

@Injectable({ providedIn: 'root' })
export class AboutSectionService {
  readonly content: AboutContent = {
    badge: 'About Ruffles & Shine',
    heading: 'Where thoughtful grooming meets genuine care.',
    lede:
      'Ruffles & Shine is built for dogs and cats who deserve calm, respectful care. We focus on gentle handling, clean studios, and stress-free visits so every pet feels safe from check-in to pickup.',
    body:
      'Our experienced groomers take a safety-first approach that works beautifully for puppies, senior pets, and anxious companions. You receive clear updates, honest recommendations, and grooming that prioritizes comfort as much as style.',
    ctaLabel: 'Meet Our Care Philosophy',
    ctaHref: '#about-us',
    imageSrc: 'assets/shared/about/about.png',
    imageAlt: 'Groomer gently brushing a calm dog in soft natural light',
    highlights: [
      {
        title: 'Gentle, pet-first grooming',
        description: 'Comfort-led techniques for relaxed, happy visits.'
      },
      {
        title: 'Clean & hygienic studio',
        description: 'Sanitized stations and fresh tools for every appointment.'
      },
      {
        title: 'Breed-aware styling',
        description: 'Looks tailored to coat type, lifestyle, and season.'
      },
      {
        title: 'Trusted by local pet parents',
        description: 'Transparent care and recommendations you can trust.'
      }
    ]
  };
}
